import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDatepickerComponent } from './base-datepicker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { GERMAN_DATE_FORMATS } from '../../utils/date-formats';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-day-datepicker',
  standalone: true,
  imports: [
    BaseDatepickerComponent,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    DatePipe
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: MAT_DATE_FORMATS, useValue: GERMAN_DATE_FORMATS },
    DatePipe
  ],
  template: `
    <div class="datepicker-container w-full overflow-hidden">
      <button mat-icon-button (click)="decrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <app-base-datepicker [date]="date" (dateChange)="onDateChange($event)">
        <div class="datepicker-container">
          <span class="datepicker-label">{{ date | date : 'dd.MM.yyyy' : 'de-DE' }}</span>
          <mat-form-field appearance="fill" class="datepicker-fieldd">
            <input matInput [matDatepicker]="picker" [value]="date" (dateChange)="onDateChange($event.value)" class="hidden-input" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </app-base-datepicker>
      <button mat-icon-button (click)="incrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./datepicker.component.css']
})
export class DayDatepickerComponent {
  private datePipe = inject(DatePipe);

  @Input() date: Date = new Date();
  @Output() dateChange = new EventEmitter<Date>();

  onDateChange(newDate: Date) {
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  incrementDate() {
    const newDate = new Date(this.date);
    newDate.setDate(newDate.getDate() + 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  decrementDate() {
    const newDate = new Date(this.date);
    newDate.setDate(newDate.getDate() - 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }
}
